import Box from 'common/components/Box'
import Button from '@material-ui/core/Button';
import DocumentTitle from 'react-document-title'
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { Translate } from 'react-i18nify-lite'
import background from 'static/login-bg.jpg'
// import meme from 'static/1kayjt.jpg'
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    container: {
        height: '100vh',
        flexGrow: 1,
        backgroundColor: '#555555',
        color: '#333333',
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
    },
    back: {
        padding: 10,
        margin: 0,
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        // '& div': {
        //     backgroundImage: `url(${meme})`,
        //     backgroundSize: 'cover',
        //     height: '395px',
        //     width: '720px',    
        // }
    },
    formContainer: {
        width: '540px',
        padding: 20,
        backgroundColor: '#ffffff',
        margin: 0
    },
    title: {
        fontSize: '24px',
        lineHeight: '29px',
        marginBottom: '30px'
    },
    formDiv: {
        padding: 8,
    },
    inputDiv: {
        marginTop: '20px'
    },
    input: {
        width: '100%'
    },
    loginButton: {
        width: '180px'
    },
    footer: {
        flex: 1,
        fontSize: '12px'
    },
    createAccountLink: {
        textDecoration: 'none'
    },
    error: {
        paddingLeft:'5px',
        color:theme.palette.error.main
    },
});

const LoginPage = ({ classes, pid, vid, handleSubmit, onSubmit, submitting, loading, errors, loginURL, ...rest }) => {
    // const submit = (type) => {
    //     return handleSubmit((values, dispatch) => onSubmit({ ...values, type: 'signIn' }, dispatch))
    // }    

    return (
        <DocumentTitle title='WaaS Support Dashboard'>
            <form onSubmit={handleSubmit}>
                {/* <MixpanelTrack msg='ViewedLoginPage' /> */}
                <Grid container className={classes.container} spacing={0}>
                    <Grid item container className={classes.back} alignItems='flex-end'>
                        <div></div>
                    </Grid>
                    <Grid item container className={classes.formContainer} direction='column'>
                        <Grid item className={classes.title}>
                        Barracuda WAF-as-a-Service - Support
                        </Grid>
                        <Box loadingAnimation={submitting || loading} border={false}>
                            <Grid item xs={12} className={classes.error}>
                                {errors}
                            </Grid>
                            <Grid item container direction='column' className={classes.formDiv} spacing={2}>
                                {/*<Grid item>*/}
                                {/*    <Field*/}
                                {/*        name="email"*/}
                                {/*        label="Email"*/}
                                {/*        component={renderTextField}*/}
                                {/*        className={classes.input}*/}
                                {/*        validate={[validator.required, validator.email]}*/}
                                {/*        autoFocus*/}
                                {/*    />*/}
                                {/*</Grid>*/}
                                {/*<Grid item>*/}
                                {/*    <Field*/}
                                {/*        type="password"*/}
                                {/*        name="password"*/}
                                {/*        label="Password"*/}
                                {/*        component={renderTextField}*/}
                                {/*        className={classes.input}*/}
                                {/*        validate={[validator.required]}*/}
                                {/*        dangerouslySetErrorInnerHTML={true}*/}
                                {/*    />*/}
                                {/*    <Field*/}
                                {/*        name="pid"*/}
                                {/*        type='hidden'*/}
                                {/*        component="input"*/}
                                {/*    />*/}
                                {/*    <Field*/}
                                {/*        name="vid"*/}
                                {/*        type='hidden'*/}
                                {/*        component="input"*/}
                                {/*    />*/}
                                {/*</Grid>*/}
                                <Grid item container justify='space-between' className={classes.inputDiv}>

                                        <Button
                                        variant="contained" color="primary"
                                        // type="submit"
                                        href={loginURL}
                                        // onClick={submit('signIn')}
                                        >
                                        <Translate value="login.signInWithBarracudaSSO" />
                                    </Button>


                                    {/* <a href="https://login.barracudanetworks.com/new_user/" className={classes.createAccountLink}>
                                        <Button variant="contained" className={classes.loginButton}>
                                            <Translate value="login.createAccount" />
                                        </Button>
                                    </a> */}
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </form >
        </DocumentTitle >
    );
};

export default withStyles(styles, { name: 'LoginPage' })(LoginPage);